import { IConfig } from './app/config'

declare global {
  interface UserLane {
    (command: string, id: string): void
  }
  interface Window {
    config: IConfig
    Userlane: (command: string, id?: string | number, attributes?: unknown) => void
  }
}

window.config = window.config || {}
window.Userlane =
  window.Userlane ||
  (() => {
    // do nothing
  })
